module.exports = __webpack_public_path__ + "img/icon-arrows-next.74ae035b.svg";